import { mapMutations, mapState } from 'vuex';

import { debounce } from '@/helpers';

export default {
    props: ['dialogData'],
    data() {
        return {
            createEntity: false, // Флаг для показа формы создания сущности
            data: [], // Данные таблицы
            page: 1, // Активная страница табличной пагинации
            pageSize: 30, // Количество итемов на "странице"
            searchValue: null, // value поисковой строки
            selection: [], // Выбранные строки в таблице
        }
    },
    methods: {
        ...mapMutations('common', ['TOGGLE_DIALOG']),
        handleSelectionChange(val) {
            this.selection = val;
        },
        setPage(val) {
            this.page = val;
        },
        sortListAsc(property) {
            // Сортировка таблицы по возрастанию
            return (a, b) => {
                const value1 = a[property];
                const value2 = b[property];

                return (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;
            };
        },
        sortListDesc(property) {
            // Сортировка таблицы по убыванию
            return (a, b) => {
                const value1 = a[property];
                const value2 = b[property];

                return (value2 < value1) ? -1 : (value2 > value1) ? 1 : 0;
            };
        }
    },
    computed: {
        ...mapState('common', ['dialogs']),
        input: {
            get() {
                return this.searchValue;
            },
            set: debounce(function(val) {
                this.page = 1; // При поиске устанавливаем активную страницу на первую
                this.searchValue = val;
            }, 30)
        },
        elDialogs() {
            return new Proxy(this.dialogs, {
                set: (target, prop, value) => {
                    this.TOGGLE_DIALOG({ [prop]: value });

                    return true;
                },
            });
        },
        total() {
            // Пагинация
            return this.filtered.length;
        }
    }
}
